/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'
import { withTranslation } from 'react-i18next'
import {
    Grid,
    Typography,
    Select,
    MenuItem
} from "@material-ui/core";

/* EQUESTRIAN select*/

function SelectCompetition(props) {
  return (
  <Grid container>
    <Grid item xs={12} sm={3} md={4} lg={3} xl={2} style={{alignSelf: 'center'}}>
      <Typography align="left" style={{margin: '0rem'}}>{props.t('events:Competition category')}</Typography>
    </Grid>
    <Grid item xs={12} sm={9} md={8} lg={9} xl={4}>

        <Select
            style={{
                textAlign: 'left'
            }}
            select
            onChange={(event) => {
                props.onChange(event);
            }}
            value={props.selected}
            fullWidth
        >
        {props.data ? props.data.length > 0 ? props.data.sort((a, b) => a.folder_id - b.folder_id).map(f => (
            <MenuItem
              key={f.folder_id}
              id={f.folder_id}
              name={f.folder_naam}
              value={f.folder_id}
              className="Select-options">
                {f.folder_naam}
            </MenuItem>
            )): null : null}
        </Select>
    </Grid>
  </Grid>
  )

}

export default React.memo(withTranslation('events')(SelectCompetition))
